import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { api } from "./api";
import { Empty } from "./components";

/** Why a usage or log view is empty: no keys at all is a different message from a quiet period. */
export function NoActivity({ quiet }: { quiet: { title: string; message: string } }) {
  const keys = useQuery({ queryKey: ["keys"], queryFn: api.keys });
  if (keys.data && keys.data.length === 0) {
    return (
      <Empty
        icon="vpn_key"
        title="You don't have a key yet"
        message="Usage and requests appear here once a tool is using one of your keys."
        action={<Link to="/keys?create=1"><forge-button variant="raised">Create a key</forge-button></Link>}
      />
    );
  }
  return <Empty title={quiet.title} message={quiet.message} />;
}
